module.exports = __webpack_public_path__ + "img/1526771351.091d72a4.jpg";